import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V54C64 59.5228 59.5228 64 54 64H10C4.47715 64 0 59.5228 0 54V10Z"
      className="bgColor"
    />
    <mask id="path-2-inside-1_2986_122335" fill="white">
      <rect x="26" y="40.3999" width="12" height="4.2" rx="0.6" />
    </mask>
    <rect
      x="26"
      y="40.3999"
      width="12"
      height="4.2"
      rx="0.6"
      className="strokeMainColor"
      strokeWidth="2.4"
      mask="url(#path-2-inside-1_2986_122335)"
    />
    <mask id="path-3-inside-2_2986_122335" fill="white">
      <rect x="29" y="24.8003" width="6.075" height="4.725" rx="0.6" />
    </mask>
    <rect
      x="29"
      y="24.8003"
      width="6.075"
      height="4.725"
      rx="0.6"
      className="strokeMainColor"
      strokeWidth="2.4"
      mask="url(#path-3-inside-2_2986_122335)"
    />
    <path
      d="M27.1996 21.6081C27.1996 21.5033 27.2519 21.4181 27.3262 21.3741C27.8448 21.0675 28.6864 20.6018 29.3065 20.3986C30.2203 20.0991 31.728 20.0132 31.9935 20.0008C31.9983 20.0005 32.0009 20.0005 32.0057 20.0008C32.2712 20.0132 33.7789 20.0991 34.6927 20.3986C35.3128 20.6018 36.1544 21.0675 36.673 21.3741C36.7473 21.4181 36.7996 21.5033 36.7996 21.6081V24.4999C36.7996 24.6656 36.6653 24.7999 36.4996 24.7999H27.4996C27.3339 24.7999 27.1996 24.6656 27.1996 24.4999V21.6081Z"
      className="strokeMainColor"
      strokeWidth="1.2"
    />
    <mask id="path-5-inside-3_2986_122335" fill="white">
      <rect x="27.1992" y="28.3999" width="9.6" height="13.2" rx="0.6" />
    </mask>
    <rect
      x="27.1992"
      y="28.3999"
      width="9.6"
      height="13.2"
      rx="0.6"
      className="strokeMainColor"
      strokeWidth="2.4"
      mask="url(#path-5-inside-3_2986_122335)"
    />
    <circle cx="24.7992" cy="27.2011" r="0.6" className="mainColor" />
    <circle cx="21.1996" cy="27.2011" r="0.6" className="mainColor" />
    <circle cx="19.4008" cy="26.0019" r="0.6" className="mainColor" />
    <circle cx="17.6" cy="27.2011" r="0.6" className="mainColor" />
    <circle cx="23.0004" cy="28.4003" r="0.6" className="mainColor" />
    <circle cx="21.1996" cy="29.6015" r="0.6" className="mainColor" />
    <circle cx="19.4008" cy="28.4003" r="0.6" className="mainColor" />
    <circle cx="17.6" cy="30.2011" r="0.6" className="mainColor" />
    <circle cx="17.6" cy="33.2011" r="0.6" className="mainColor" />
    <circle cx="17.6" cy="24.2011" r="0.6" className="mainColor" />
    <circle cx="17.6" cy="21.2011" r="0.6" className="mainColor" />
    <circle cx="19.4008" cy="31.4003" r="0.6" className="mainColor" />
    <circle cx="23.0004" cy="26.0019" r="0.6" className="mainColor" />
    <circle cx="21.1996" cy="24.8007" r="0.6" className="mainColor" />
    <circle cx="19.4008" cy="23.0019" r="0.6" className="mainColor" />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 39.8008 26.6011)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 43.4004 26.6011)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 45.1992 25.4019)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 47 26.6011)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 41.5996 27.8003)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 43.4004 29.0015)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 45.1992 27.8003)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 47 29.6011)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 47 32.6011)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 47 23.6011)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 47 20.6011)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 45.1992 30.8003)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 41.5996 25.4019)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 43.4004 24.2007)"
      className="mainColor"
    />
    <circle
      cx="0.6"
      cy="0.6"
      r="0.6"
      transform="matrix(-1 0 0 1 45.1992 22.4019)"
      className="mainColor"
    />
  </svg>
);

const IrrigationIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default IrrigationIcon;
